import {useState, useEffect, useContext } from "react";
import { AppContext } from '../ApplicationContext';

export const isAudioRecorderSupported : boolean = (navigator.mediaDevices !== null) && (navigator.mediaDevices.getUserMedia !== null);

export interface IAudioRecorderProps {

    onRecordingStart : () => void;
    onRecordingEnd : () => void;

}

export const AudioRecorder =  ( props : IAudioRecorderProps ) => {

    let  recordingInterval = null;

    const context = useContext(AppContext);

    const [isRecording, setIsRecording] = useState(false);
    
    const [recordingStartTime, setRecordingStartTime] = useState<Date>(new Date());

    const [timer, setTimer] = useState("");

    const [recorder, setRecorder] = useState(null);

    const [buffer, setBuffer] = useState([]);

    const [upload, setUpload] = useState(false);

    const createDragImage = (type: "blank"|"recording") => {

         var img = document.createElement("img");   

         switch(type){
            case "recording":
                img.src = "data:image/png;base64,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";
                break;

            case "blank":
            //default:
                img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

         }
       
         return img;
    };

    const dragImage = createDragImage("blank");

   const isCancel = (e) : boolean => {
   
       let btn = $('#btnRecord');
       let track = $('.mr-audio-cancel-drag-track');
       let rect = track[0].getBoundingClientRect();
       let rectButton = btn[0].getBoundingClientRect();

       let mouseX = e.touches && e.touches.length>0 ? e.touches[0].clientX : e.changedTouches && e.changedTouches.length > 0 ?e.changedTouches[0].clientX:  e.clientX;


       let isLeft : boolean = mouseX < rect.left + (rect.width/2);

       return isLeft;

   }

    const stopDevices = () => {
        
        if(recorder) {

            let stream = recorder.stream;

            if(stream) {
                stream.getTracks() 
                      .forEach( track => {
                          track.stop();
                          track.enabled = false;
                      } ); 
            }

            recorder.onstop = onMediaRecorderStopped
            recorder.stop();
        }

        setRecorder(null);
        setTimer("");

    }

    const startRecording = async (reason:string) =>  {
    
        if(!isAudioRecorderSupported) 
        {   
             return;
        }

        if(!isRecording) {
            return;
        }

        console.log("startRecording" ,{reason:reason});

        try {

            stopDevices();

            setTimer("00:00");
            setRecordingStartTime( () => new Date() );

            props.onRecordingStart(); //earlier / sooner?

            let btn = $('#btnRecord');
            btn.addClass('mr-audio-recording');

            let track = $('.mr-audio-cancel-drag-track');
            track.addClass('mr-audio-recording');
            
            let stream = await navigator.mediaDevices.getUserMedia({audio: true}) ;
            
            let mediaRecorder = new MediaRecorder(stream);

            mediaRecorder.ondataavailable = onMediaRecorderData;
            //mediaRecorder.onstop = onMediaRecorderStopped;

            setBuffer([]);

            setRecorder(mediaRecorder);

            setIsRecording(true);

            mediaRecorder.start();


        } catch(err){
    
            setIsRecording(false);
            
        }

    }


    const stopRecording = () : void =>
    {

        console.log("stopRecording :: ",{upload:upload});

        stopDevices();

        setIsRecording(false);

        let btn = $('#btnRecord');
        let track = $('.mr-audio-cancel-drag-track');
        
        btn.css({left: ''});
        
        btn.removeClass('mr-audio-recording');
        
        track.removeClass('mr-audio-recording');

        props.onRecordingEnd();

    }




    

    const onMediaRecorderData = (e) => {
    
        setBuffer([...buffer, e.data]);

    }

    const onRecordingDragOver = (e) => {

        //if(!isRecording)
        //{
        //    return;
        //}

        if(!isCancel(e)) {

            e.preventDefault();
            e.stopPropagation();

        }
            
        
    }


    const [clickerTimeout, setClickerTimeout] = useState([]);
    
    const onRecordingClick = (e) => {
   
       //TODO: Maybe replace this with dynamically added and removed handlers, carefull with mouse moving out of btn, then attach to window

       console.log("onRecordingClick");

       //Timeout prevents a mousedown interfering with a click event
       if(clickerTimeout){

           clickerTimeout.forEach(to=>{clearTimeout(to);})
           setClickerTimeout([]);
           console.log("clickerTimeout cleared");
       }

       if(isRecording) {
            
           setUpload(!isCancel(e));
           setIsRecording(false);
           //stopRecording();

        } else {

            setIsRecording(true);
            //startRecording(e.type);

        }

       /*

       if(e.type === "mousedown" && isRecording) {
           onRecordingDragEnd(e);
       } else if(e.type === "mousedown" && !isRecording) {
           onRecordingDragStart(e);
       
       } else if (e.type === "mouseup" && isRecording) {
           onRecordingDragEnd(e);
       } else if (e.type === "mouseup" && !isRecording) {
            //do not start recording
            return;
       } else if(e.type === "click" && isRecording) {
           onRecordingDragEnd(e);
       } else if(e.type === "click" && !isRecording){
           onRecordingDragStart(e);
       }
       
       */
   }

    

   const onRecordingMouseDown = (e) => {

       console.log("onRecordingMouseDown");

       //Timeout prevents a mousedown interfering with a click event
      setClickerTimeout([...clickerTimeout, setTimeout(()=>{
      
           console.log("onRecordingMouseDown: Timeout");

           if(isRecording) {

               //Do not stop recording: start a recording BY  CLICK, then press to start dragging

               //setUpload(!isCancel(e));
               //setIsRecording(false);
               //stopRecording();

            } else {

                setIsRecording(true);

                //startRecording(e.type);

            }

      },350)])
       

        //window.document.addEventListener("mouseup", onRecordingMouseUp);

   }

   const onRecordingMouseUp = (e) => {
   
       console.log("onRecordingMouseUp");
       
        setClickerTimeout([...clickerTimeout, setTimeout(()=>{

            console.log("onRecordingMouseUp:: Timer");

           if(isRecording) {

               setUpload(!isCancel(e));
               setIsRecording(false);
               //stopRecording();

           } else {
       
               //do not start recording

           }

        }, 350)]);

   }

   const onRecordingDragStart = (e) => {
   
       console.log("onRecordingDragStart");
       if(clickerTimeout){

           clickerTimeout.forEach(to=>{clearTimeout(to);})
           setClickerTimeout([]);
           console.log("clickerTimeout cleared");
       }

       e.dataTransfer.setData("audioRecording", "true");
       e.dataTransfer.setDragImage(dragImage,0,0);

       setIsRecording(true);
       //startRecording(e);

   }

   const onRecordingDrag = (e) => {
       
       //e.preventDefault();
       
       let btn = $('#btnRecord');
       let track = $('.mr-audio-cancel-drag-track');
       let rect = track[0].getBoundingClientRect();
       let rectButton = btn[0].getBoundingClientRect();
       
       let mouseX = e.touches && e.touches.length>0 ? e.touches[0].clientX : e.changedTouches && e.changedTouches.length > 0 ?e.changedTouches[0].clientX:  e.clientX;


       let x : number = mouseX < rect.left + rectButton.width ? rect.left + rectButton.width: mouseX;

       x = x > rect.left + rect.width -  rectButton.width  ? rect.left + rect.width : x;

       //e.dataTransfer.setDragImage(dragImage,0,0);

       console.log("onRecordingDrag",{e:e,x:x});

       btn.css({left: x  + 'px'});

       if(isCancel(e))
       {
           track.addClass("mr-record-audio-cancel");
       } else {
           track.removeClass("mr-record-audio-cancel");
       }

   }


   const onRecordingDragEnd = (e) => {
        
       console.log("onRecordingDragEnd",{e:e});

       e.preventDefault();
       
       setUpload(!isCancel(e));
       setIsRecording(false);
       //stopRecording();
              
   }

   const onMediaRecorderStopped = (e) => {
       
       //Redundant, could be removed
       //console.log("onMediaRecorderStopped: SUSPECT");
       //setIsRecording(false);

       setIsUploading(true);

       console.log("onMediaRecorderStopped [DO UPLOAD HERE? IsUploading set]", {upload:upload, isRecording:isRecording});
        
   }

   const [isUploading, setIsUploading] = useState(false);

   
  // console.log("------------------- RENDER ------------------- ",{isRecording: isRecording, upload:upload});
   //if(recorder) {
   //    recorder.removeEventListener("stopped", onMediaRecorderStopped);
   //    recorder.addEventListener("stopped", onMediaRecorderStopped);
   //}

   useEffect( () => {
   
       console.log("Effect (isRecording)", {isRecording:isRecording, upload:upload,isUploading: isUploading});

       if(isRecording) {
       
           startRecording("effect");

       } else {
       
           stopRecording();

       }

   }, [isRecording]);

   useEffect( ()=> {
   
       console.log("Effect (isUploading)", {isRecording:isRecording, upload:upload,isUploading: isUploading});
       
       if(upload && isUploading/* && !(isRecording) && buffer && buffer.length>0*/) {

            

            const time = Date.now() - (recordingStartTime as any);
            const seconds = (time / 1000) % 60;

            if(seconds > 0.5 && buffer && buffer.length > 0) {
                console.log("uploading audio");
                context.messenger.sendAudio( new Blob(buffer, {type: buffer[0].type}) );
            } else {
                console.log("TOO SHORT, AUDIO UPLOAD SKIPPED", {seconds:seconds, buffer:buffer});
            }

            setUpload(false);
            
           
        }
        if(isUploading) {
            setIsUploading(false);
        }
        setIsUploading(false);
        setBuffer([]);

   }, [isUploading])

  

    window.document.ondragover = onRecordingDragOver;
    
   
    
    useEffect(()=> {
        
       // console.log("Effect (isRecording,recordingStartTime )");

        let interval = setInterval(()=> {

            if(!isRecording)
                return;

            const time = Date.now() - (recordingStartTime as any);
            const minutes = ("0" + (Math.floor((time / 1000 / 60) % 60)).toString() ).slice(-2);
            const seconds = ("0" + (Math.floor((time / 1000) % 60)).toString() ).slice(-2);

            setTimer(minutes + ":" + seconds);
            
        },500);
        
        return function cleanup()  { clearInterval(interval) };

    },[recordingStartTime, isRecording]);
    

    useEffect(()=> {
    /*
        if(upload && !(isRecording) && buffer && buffer.length>0) {

            setUpload(false);

            const time = Date.now() - (recordingStartTime as any);
            const seconds = (time / 1000) % 60;

            if(seconds > 0.5) {
                context.messenger.sendAudio( new Blob(buffer, {type: buffer[0].type}) );
            } else {
                console.log("TOO SHORT, AUDIO UPLOAD SKIPPED");
            }

            setBuffer([]);

            

        }
       */
    }, [upload, isRecording, buffer]);












    
  
    

    return <>
        {isAudioRecorderSupported && <div onDragOver={onRecordingDragOver}>
            
            <div 
                className={"mr-audio-cancel-drag-track " + (isRecording ? "mr-audio-recording":"" )} 
                
                >

                <div className="mr-recorder-timer"><i className="bi bi-mic"/><span>{timer}</span></div>
                <div className="mr-recorder-hint"><i className="bi bi-chevron-compact-left"/><span onClick={(e)=> {setUpload(false);setIsRecording(false);/*stopRecording()*/}}>slide or click to cancel</span></div>

            </div>


            <button 
                    id="btnRecord"
                    type="button"
                    className={"btn btn-primary " + (isRecording ? "mr-audio-recording":"" )}
                    
                    onClick={onRecordingClick}
                    onMouseDown={onRecordingMouseDown}
                    onMouseUp={onRecordingMouseUp}
                    onTouchEnd={onRecordingDragEnd}
                    onDragStart={onRecordingDragStart} 
                    onDrag={onRecordingDrag}
                    onTouchMove={onRecordingDrag}
                    onDragEnd={onRecordingDragEnd}

                    onDragOver={onRecordingDragOver}

                    draggable={true}
                    title="Neem een audio berichtje op"
                    >
                    <i className={isRecording ? "bi bi-send":"bi bi-mic" }/>
                </button>

            {/*



            {(!isRecording) && <>

                <button className="btn btn-secondary" onClick={onStartRecording}><i className="bi bi-mic"/></button>

                </>
            } 

            {isRecording && <>

                <div className="mr-recorder mr-audio-recorder btn btn-group">

                    <button className="btn btn-sm btn-outline-secondary " onClick={onCancelRecording}>
                        <i className="bi bi-x-square"/>
                    </button>

                    <button className="btn btn-outline-secondary" onClick={onSendRecording}>
                        <div className="mr-recorder-timer"><i className="bi bi-record-circle"/><span>{timer}</span><i className="bi bi-send"/></div>
                    </button>

                </div>


                </>
            }

            */}
            </div>
        }
        
    </>

}




                        /*

    const onStartRecording = async (e) => {

    
        if(!isAudioRecorderSupported) 
            return;

        try {

            setTimer("00:00");
            setRecordingStartTime(()=> new Date());
            
            if(stream) {
                stream.getTracks() 
                .forEach( track => {track.stop();track.enabled = false;} ); // stop each of them
            }
            
            var s = await navigator.mediaDevices.getUserMedia({audio: true}) ;
            setStream( s );
            

            let mediaRecorder = new MediaRecorder(s);

            mediaRecorder.ondataavailable = onMediaRecorderData;
            mediaRecorder.onstop = onStopped;

            setBuffer([]);

            setRecorder(mediaRecorder);

            setIsRecording(true);

            mediaRecorder.start();

            

        } catch(err){
    
            setIsRecording(false);
            
        }
        
    }

    const onStopRecording = (e) => {
    
        if(stream) {
            stream.getTracks() // get all tracks from the MediaStream
            .forEach( track => {track.stop();} ); // stop each of them
        }

        if(recorder) {

            recorder.stop();
            
        } else {
           
        }

        setTimer("");
           

    }

    const onCancelRecording = (e) => {
    
        setUpload(false);
        setBuffer([]);
        onStopRecording(e);
        
    }

    const onSendRecording = (e) => {
    
        setUpload(true);
        onStopRecording(e);
        

    }

    const onStopped = (e) => {
       
        setIsRecording(false);

        if(stream) {
            stream.getTracks() // get all tracks from the MediaStream
                  .forEach( track => {track.stop();track.enabled = false;} ); // stop each of them
        }

        if(recorder) {
            recorder.stop();
        }

    };


    

    const onRecordingDrop = (e) => {
        
    }

   

   
  
   const onRecordingDragStart = (e)  => {

       if(e.type==="click" && isRecording)
       {
           //console.log("onRecordingDragStart correctly cancelled bc mouseup and mouseclick",e);
           return;
       }

       if(stream) {
           stream.getTracks().forEach( track => { track.stop(); track.enabled = false;} ); // stop each of them
       }

       if(recorder) {
           recorder.stop();
       }

       setIsRecording(true);

        //console.log("onRecordingDragStart",e);

        props.onRecordingStart();

        if(e.dataTransfer) {

            e.dataTransfer.setData("text", e.target.id);
            e.dataTransfer.setDragImage(dragImage,0,0);
        
        }
        

        let btn = $('#btnRecord');
        btn.addClass('mr-audio-recording');

        let track = $('.mr-audio-cancel-drag-track');
        track.addClass('mr-audio-recording');

        onStartRecording(e);
    }


   const onRecordingDrag = (e) => {
       
       e.preventDefault();
       
       let btn = $('#btnRecord');
       let track = $('.mr-audio-cancel-drag-track');
       let rect = track[0].getBoundingClientRect();
       let rectButton = btn[0].getBoundingClientRect();
       

       let x = e.clientX < rect.left + rectButton.width ? rect.left + rectButton.width: e.clientX;

       x = x > rect.left + rect.width -  rectButton.width  ? rect.left + rect.width : x;

       e.dataTransfer.setDragImage(dragImage,0,0);

       btn.css({left: x});

       if(isCancel(e))
       {
           track.addClass("mr-record-audio-cancel");
       } else {
           track.removeClass("mr-record-audio-cancel");
       }

   }

   

   const onRecordingDragEnd = (e, action:string="default") => {
        
       
       e.preventDefault();
        
        //console.log("onRecordingDragEnd",e);
        
        let btn = $('#btnRecord');
        
        let track = $('.mr-audio-cancel-drag-track');
        

       let rect = track[0].getBoundingClientRect();
       let rectButton = btn[0].getBoundingClientRect();

     
        if(isCancel(e) || action === "cancel") {
            //console.log("CANCEL");
            onCancelRecording(e);
        } else {
            //console.log("SEND");
            onSendRecording(e);
        }


        btn.css({left: "unset"});
        btn.removeClass('mr-audio-recording');
        
        track.removeClass('mr-audio-recording');
        props.onRecordingEnd();
   }
   */